<template functional>
  <div class="px-4">
    <vx-card :class="data.staticClass">
      <!-- MAIL HEAD -->
      <div class="vx-row">
        <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
          <!-- Sender Details -->
          <div class="flex items-center">
            <div class="flex flex-col">
              <h5 class="mb-1">{{ props.mailContent.username }}</h5>
              <div class="flex items-center">
                <span class="text-sm">{{ props.mailContent.email }}</span>
                <vs-dropdown vs-custom-content vs-trigger-click class="inline-flex cursor-pointer">
                  <feather-icon icon="ChevronDownIcon" class="w-3 h-3" />
                  <vs-dropdown-menu style="z-index: 40001">
                    <div class="p-2">
                      <p class="text-sm mb-1">From: <span class="font-semibold"> {{ props.mailContent.email }} </span></p>
                      <p class="text-sm mb-1">To: <span class="font-semibold"> {{ props.mailContent.file }} </span></p>
                      <p class="text-sm mb-1">Date: <span class="font-semibold"> {{ props.mailContent.created_at }} {{ props.mailContent.created_at | date(true) }} </span></p>
                      <p class="text-sm mb-1" v-if="props.mailContent.file">cc: <span class="font-semibold"> {{ props.mailContent.file }} </span></p>
                    </div>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </div>
          <!-- /Sender Details -->

          <!-- Mail Time & Date -->
          <div class="flex flex-col justify-end">
            <span class="text-right">{{ props.mailContent.created_at | time }}</span>
            <div class="flex justify-end mt-2">
              <span class="text-right">{{ props.mailContent.created_at | date(true) }}</span>
            </div>
          </div>
        </div>
        <!-- /Mail Time & Date -->
      </div>

      <!-- MAIL CONTENT -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>ID | Номер:</b> #{{ props.mailContent.id }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Имя отправителя:</b> {{ props.mailContent.username }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Тема:</b> {{ props.mailContent.subject }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Направление:</b> {{ props.mailContent.category.name }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Статус запроса:</b>
            <br>
            <vs-chip color="primary" class="px-4 py-2 mr-3">{{ props.mailContent.status }}</vs-chip>
          </div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Телефон:</b> {{ props.mailContent.phone ? props.mailContent.phone : '-' }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Комментария клиента:</b> {{ props.mailContent.note_client }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Авторы:</b> {{ props.mailContent.authors }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Ответственный email:</b> {{ props.mailContent.category.owner_email }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Ответ:</b> {{ props.mailContent.answer_text }}</div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Ссылка для оплаты:</b>&nbsp;&nbsp; <a target="_blank" :href="props.mailContent.payment_link ? props.mailContent.payment_link : '#'">{{ props.mailContent.payment_link ? props.mailContent.payment_link : 'Не добавлено' }}</a></div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Статус оплаты:</b>
            <br>
            <vs-chip color="primary" class="px-4 py-2 mr-3">{{ props.mailContent.payment_status }}</vs-chip>
          </div>
        </div>
        <div class="vx-col w-full">
          <div class="mail__content break-words mt-8 mb-4"><b>Скачать файл:</b> <a target="_blank" :href="`https://api.conferences-list.uz/storage/${ props.mailContent.file}`"> https://api.conferences-list.uz/storage/{{ (props.mailContent.file) }}</a></div>
        </div>
        <div class="vx-col w-full" v-if="props.mailContent.user_files && Object.assign([], props.mailContent.user_files).length">
          <h3>Обработанные файлы</h3>
          <div class="mail__content break-words mt-8 mb-4" v-for="(file, index) in props.mailContent.user_files" :key="index"><b>Файл {{ index }} , Версия: {{file.version}}:</b>
            <br>
            <a target="_blank" :href="`https://api.conferences-list.uz/storage/${ file.file_path }`">
              https://api.conferences-list.uz/storage/{{ (file.file_path) }}
            </a>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data:() => ({
    active: false,
    active2: false,
    active3: false,
    input1: ''
  }),
  props: {
    mailContent: {
      type: Object,
      required: true
    }
  }
}
</script>
